import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import UploadField from 'components/fields/UploadField';

import { createPatientDocument } from 'redux/modules/patientsDocuments';
import { addNotification } from 'redux/modules/notifications';

const styles = () => ({
  buttons: {
    marginTop: 20,
  },
  buttonsCreate: {
    textAlign: 'right',
  },
  button: {
    '& + $button': {
      marginLeft: 20,
    },
  },
  formError: {
    marginBottom: 16,
  },
  checkboxField: {
    marginBottom: 8,
  },
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});
function onSubmit(values, dispatch, props) {
  return new Promise((resolve, reject) => {
    dispatch(createPatientDocument({
      values: {
        'Record Number': props.patient['Record Number'],
        ...values,
      },
      resolve,
      reject,
    }));
  })
    .then((res) => {
      dispatch(props.reset());
      return res;
    },
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

function onSubmitSuccess(values, dispatch) {
  dispatch(addNotification({
    message: `"${values['File Name']}" was saved to chart Documents`,
    variant: 'success',
  }));
}

function onChange(values, dispatch, props) {
  if (values.Document.name) {
    props.submit();
  }
}

const DocumentsDragAndDropForm = ({
  handleSubmit,
  className,
  submitting,
}) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Field
      id="Document"
      name="Document"
      component={UploadField}
      variant="document"
      label="Drag file here or attach it"
      loading={submitting}
      fullWidth
    />
  </form>
);

DocumentsDragAndDropForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

DocumentsDragAndDropForm.defaultProps = {
  initialValues: {},
  error: null,
  className: '',
};

export default reduxForm({
  onSubmit,
  onSubmitSuccess,
  onChange,
  form: 'patientDocumentsDragAndDrop',
  initialValues: {
    Document: {
      name: null,
    },
  },
})(withStyles(styles)(DocumentsDragAndDropForm));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Documents/DocumentsDragAndDropForm.js